<template>
  <TimeslotDashboardLayout>
    <div class="main-content message">
      <div class="message-wrapper">
        <div class="user-wrappers">
          <form action="/search" class="search-2 w-form" v-if="search">
            <label for="search" class="field-label">Search</label>
            <input
              type="search"
              class="search-input-2 w-input"
              maxlength="256"
              name="query"
              placeholder="Search for a user"
              id="search-2"
              v-model="searchValue"
              @input="searchMessages"
            />
            <input
              type="submit"
              value=""
              data-w-id="50ae2d26-a603-491c-218a-c00a31a9612b"
              class="cloese-search-btn w-button"
            />
            <a
              data-w-id="c1800641-37e3-d0a6-0332-658ad854955b"
              href="#"
              class="close-search-btn w-button"
              @click="closeSearch"
            ></a>
          </form>

          <div class="message-header" v-if="header">
            <div>
              <div class="text-block-28">Messages</div>
            </div>
            <div class="div-block-34">
              <div
                data-w-id="57dcfa6b-5575-21f0-6a43-2fbdc20400c2"
                class="add-new-message w-button"
                @click="showMessage"
              ></div>
              <a
                data-w-id="ced71869-3d52-05a3-ab8f-a5d4f452a7c7"
                href="#"
                class="open-search-btn w-button"
                @click="openSearch"
              ></a>
              <!--                            <div data-hover="false" data-delay="0" class="w-dropdown">-->
              <!--                <div-->
              <!--                  class="dropdown-toggle-4 w-dropdown-toggle"-->
              <!--                  @click="toggleNav"-->
              <!--                ></div>-->
              <!--                &lt;!&ndash;                <nav class="msg-dropdown w-dropdown-list" v-if="nav">&ndash;&gt;-->
              <!--                &lt;!&ndash;                  <a href="#" class="msg-link w-dropdown-link">Inbox</a>&ndash;&gt;-->
              <!--                &lt;!&ndash;                  <a href="#" class="msg-link w-dropdown-link"&ndash;&gt;-->
              <!--                &lt;!&ndash;                    >Archived Chats</a&ndash;&gt;-->
              <!--                &lt;!&ndash;                  >&ndash;&gt;-->
              <!--                &lt;!&ndash;                  <a href="#" class="msg-link w-dropdown-link"&ndash;&gt;-->
              <!--                &lt;!&ndash;                    >Pending Requests</a&ndash;&gt;-->
              <!--                &lt;!&ndash;                  >&ndash;&gt;-->
              <!--                &lt;!&ndash;                  <a href="#" class="msg-link w-dropdown-link"&ndash;&gt;-->
              <!--                &lt;!&ndash;                    >Rejected Requests</a&ndash;&gt;-->
              <!--                &lt;!&ndash;                  >&ndash;&gt;-->
              <!--                &lt;!&ndash;                </nav>&ndash;&gt;-->
              <!--              </div>-->
            </div>
          </div>
          <div class="empty-message" v-if="customerMessages.length === 0">
            No messages
          </div>
          <div v-else>
            <div
              data-w-id="49927b11-c08f-7741-2ca1-0500629a0731"
              class="div-block-35 w-inline-block"
              v-for="(message, index) in customerMessages"
              @click="viewMessage(message)"
              :key="index"
            >
              <!--              src="@/assets/timeslot-images/user.png"-->
              <div class="div-block-36">
                <img
                  :src="
                    message.messageParticipantPicture ||
                      require('@/assets/timeslot-images/profileImg.svg')
                  "
                  loading="lazy"
                  alt=""
                  class="image-11"
                />
              </div>
              <div class="div-block-37">
                <div class="text-block-29">
                  {{ message.messageParticipantName }}
                </div>
                <div class="text-block-30">{{ message.messageBody }}</div>
              </div>
              <div class="text-block-31">
                <!--                {{ timeFromNow(new Date(message.messageCreatedAt)) }}-->
                <!--                <time-ago-->
                <!--                  :datetime="message.messageCreatedAt"-->
                <!--                  refresh-->
                <!--                  locale="en"-->
                <!--                  :long="true"-->
                <!--                />-->
                {{ formattedDate(message.messageCreatedAt) }}
              </div>
            </div>
          </div>
        </div>

        <div class="chat-area" v-if="customerMessages.length === 0">
          <div class="empty-message-container">
            <img
              src="@/assets/timeslot-images/messageNew.svg"
              width="50"
              height="50"
            />
            <div class="new-message">No messages yet</div>
            <div class="new-message-sub">
              Messages sent after connecting<br />
              with a client will <br />
              appear here.
            </div>
          </div>
        </div>

        <div class="chat-area" v-else>
          <div class="div-block-38">
            <div class="div-block-39">
              <div class="close-btn w-button"></div>
              <img
                :src="
                  singleMessageGroup.messageParticipantPicture ||
                    require('@/assets/timeslot-images/profileImg.svg')
                "
                loading="lazy"
                width="30"
                alt=""
                class="image-12"
              />
              <div class="text-block-32">
                {{ singleMessageGroup.messageParticipantName }}
              </div>
            </div>
            <div class="div-block-40">
              <!--              <div data-hover="false" data-delay="0" class="w-dropdown">-->
              <!--                <div-->
              <!--                  class="dropdown-toggle-4 w-dropdown-toggle"-->
              <!--                  @click="toggleNav2"-->
              <!--                ></div>-->
              <!--                <nav-->
              <!--                  class="msg-dropdown-copy w-dropdown-list w&#45;&#45;open"-->
              <!--                  v-if="nav2"-->
              <!--                >-->
              <!--                  <a href="#" class="msg-link w-dropdown-link">Delete Chat</a>-->
              <!--                  <a href="#" class="msg-link w-dropdown-link">Archive Chat</a>-->
              <!--&lt;!&ndash;                  <a href="#" class="msg-link block w-dropdown-link"&ndash;&gt;-->
              <!--&lt;!&ndash;                    >Block Idris</a&ndash;&gt;-->
              <!--&lt;!&ndash;                  >&ndash;&gt;-->
              <!--                </nav>-->
              <!--              </div>-->
            </div>
          </div>
          <div class="div-block-41">
            <BaseComponentLoader
              v-if="
                loader.nonBlockingLoader &&
                  !send &&
                  !acceptLoading &&
                  !declineLoading
              "
              loaderAlignment="center"
            />
            <div v-else id="messageContainer" class="scroll-parent">
              <div
                :class="
                  message.messageFrom ===
                  userInfo.professional.professionalCustomerId
                    ? 'sender-message-wrapper'
                    : 'recipient-message-wrapper'
                "
                v-for="(message, index) in messagesInGroup"
                :key="index"
              >
                <img
                  v-if="
                    message.messageFrom !==
                      userInfo.professional.professionalCustomerId
                  "
                  :src="
                    singleMessageGroup.messageParticipantPicture ||
                      require('@/assets/timeslot-images/profileImg.svg')
                  "
                  loading="lazy"
                  alt=""
                  class="image-13"
                />
                <div
                  :class="
                    message.messageFrom ===
                    userInfo.professional.professionalCustomerId
                      ? 'div-block-44-copy'
                      : 'div-block-44'
                  "
                >
                  <p class="paragraph-3">
                    {{ message.messageBody }}
                  </p>
                </div>

                <img
                  v-if="
                    message.messageFrom ===
                      userInfo.professional.professionalCustomerId
                  "
                  :src="
                    profInfo.customerDisplayPicture ||
                      require('@/assets/timeslot-images/profileImg.svg')
                  "
                  loading="lazy"
                  alt=""
                  style="margin-left: 13px; margin-right:0;"
                  class="image-13"
                />
              </div>
            </div>
            <div
              class="div-block-180 messages-bottom-margin"
              v-if="
                messagesInGroup.filter(item => item.messageStatus === 'PENDING')
                  .length !== 0 &&
                  !acceptSuccess &&
                  !declineSuccess
              "
            >
              <BaseComponentLoader
                v-if="
                  loader.nonBlockingLoader && acceptLoading && !declineLoading
                "
                loaderAlignment="center"
              />

              <div
                class="accept-button accept w-button"
                v-else
                @click="acceptMessage"
              >
                Accept message request
              </div>

              <!--              <a href="#" class="accept-button accept w-button" v-else>-->
              <!--                <div class="small-loader" :style="{ textAlign: 'center' }">-->
              <!--                  <div class>-->
              <!--                    <div class="jt">-->
              <!--                      <svg height="100%" viewBox="0 0 32 32" width="100%">-->
              <!--                        <circle-->
              <!--                          cx="16"-->
              <!--                          cy="16"-->
              <!--                          fill="none"-->
              <!--                          r="14"-->
              <!--                          stroke-width="4"-->
              <!--                          style="stroke: #FFFFFF; opacity: 0.2;"-->
              <!--                        />-->
              <!--                        <circle-->
              <!--                          cx="16"-->
              <!--                          cy="16"-->
              <!--                          fill="none"-->
              <!--                          r="14"-->
              <!--                          stroke-width="4"-->
              <!--                          style="stroke: #FFFFFF; stroke-dasharray: 80; stroke-dashoffset: 60;"-->
              <!--                        />-->
              <!--                      </svg>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </a>-->

              <BaseComponentLoader
                v-if="
                  loader.nonBlockingLoader && !acceptLoading && declineLoading
                "
                loaderAlignment="center"
              />

              <div
                class="decline-button decline w-button"
                v-else
                @click="declineMessage"
              >
                Decline message request
              </div>

              <!--              <a href="#" class="decline-button decline w-button" v-else>-->
              <!--                <div class="small-loader" :style="{ textAlign: 'center' }">-->
              <!--                  <div class>-->
              <!--                    <div class="jt">-->
              <!--                      <svg height="100%" viewBox="0 0 32 32" width="100%">-->
              <!--                        <circle-->
              <!--                          cx="16"-->
              <!--                          cy="16"-->
              <!--                          fill="none"-->
              <!--                          r="14"-->
              <!--                          stroke-width="4"-->
              <!--                          style="stroke: #256ff6; opacity: 0.2;"-->
              <!--                        />-->
              <!--                        <circle-->
              <!--                          cx="16"-->
              <!--                          cy="16"-->
              <!--                          fill="none"-->
              <!--                          r="14"-->
              <!--                          stroke-width="4"-->
              <!--                          style="stroke: #256ff6; stroke-dasharray: 80; stroke-dashoffset: 60;"-->
              <!--                        />-->
              <!--                      </svg>-->
              <!--                    </div>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--              </a>-->
            </div>
          </div>
          <div class="div-block-42">
            <div class="div-block-43">
              <div class="button-7 w-button"></div>
              <textarea
                class="text-field-2 w-input"
                maxlength="256"
                rows="1"
                columns="50"
                name="field"
                data-name="Field"
                placeholder="Type a message here..."
                id="field"
                required=""
                v-model="createModel.messageBody"
              />
              <BaseComponentLoader
                v-if="loader.nonBlockingLoader && send"
                loaderAlignment="center"
              />
              <div
                v-else
                class="button-8 w-button"
                @click="createMessage"
              ></div>
            </div>
          </div>
        </div>
        <div style="display:none" class="chat-area mobile">
          <div class="div-block-38">
            <div class="div-block-39">
              <a
                data-w-id="1cb9c9be-0e37-f76f-1b15-517a5a8f6a9b"
                href="#"
                class="close-btn w-button"
              ></a
              ><img
                src="@/assets/timeslot-images/pic.png"
                loading="lazy"
                width="30"
                alt=""
                class="image-12"
              />
              <div class="text-block-32">Idris Yusuf</div>
            </div>
            <div class="div-block-40">
              <div data-hover="false" data-delay="0" class="w-dropdown">
                <div class="dropdown-toggle-4 w-dropdown-toggle"></div>
                <nav class="msg-dropdown-copy w-dropdown-list">
                  <a href="#" class="msg-link w-dropdown-link">Delete Chat</a>
                  <a href="#" class="msg-link w-dropdown-link">Archive Chat</a>
                  <a href="#" class="msg-link block w-dropdown-link"
                    >Block Idris</a
                  >
                </nav>
              </div>
            </div>
          </div>
          <div class="div-block-41">
            <div class="recipient-message-wrapper">
              <img
                src="@/assets/timeslot-images/user.png"
                loading="lazy"
                alt=""
                class="image-13"
              />
              <div class="div-block-44">
                <p class="paragraph-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse varius enim in
                </p>
              </div>
            </div>
            <div class="sender-message-wrapper">
              <div class="div-block-44-copy">
                <p class="paragraph-3-copy">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse varius enim in eros elementum tristique. Duis
                  cursus, mi quis viverra ornare, eros dolor interdum nulla, ut
                  commodo diam libero vitae erat. Aenean faucibus nibh et justo
                  cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus
                  tristique posuere.
                </p>
              </div>
              <img
                src="@/assets/timeslot-images/user.png"
                loading="lazy"
                alt=""
                class="image-13-copy"
              />
            </div>
            <div class="recipient-message-wrapper">
              <img
                src="@/assets/timeslot-images/user.png"
                loading="lazy"
                alt=""
                class="image-13"
              />
              <div class="div-block-44">
                <p class="paragraph-3">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse varius enim in
                </p>
              </div>
            </div>
            <div class="sender-message-wrapper">
              <div class="div-block-44-copy">
                <p class="paragraph-3-copy">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse varius enim in eros elementum tristique. Duis
                  cursus, mi quis viverra ornare, eros dolor interdum nulla, ut
                  commodo diam libero vitae erat. Aenean faucibus nibh et justo
                  cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus
                  tristique posuere.
                </p>
              </div>
              <img
                src="@/assets/timeslot-images/user.png"
                loading="lazy"
                alt=""
                class="image-13-copy"
              />
            </div>
            <div class="sender-message-wrapper">
              <div class="div-block-44-copy">
                <p class="paragraph-3-copy">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Suspendisse varius enim in eros elementum tristique. Duis
                  cursus, mi quis viverra ornare, eros dolor interdum nulla, ut
                  commodo diam libero vitae erat. Aenean faucibus nibh et justo
                  cursus id rutrum lorem imperdiet. Nunc ut sem vitae risus
                  tristique posuere.
                </p>
              </div>
              <img
                src="@/assets/timeslot-images/user.png"
                loading="lazy"
                alt=""
                class="image-13-copy"
              />
            </div>
          </div>
          <div class="div-block-42">
            <div class="div-block-43">
              <a href="#" class="button-7 w-button"></a
              ><input
                type="text"
                class="text-field-2 w-input"
                maxlength="256"
                name="field-2"
                data-name="Field 2"
                placeholder="Type a message here..."
                id="field-2"
                required=""
                v-model="createModel.messageBody"
              />
              <div class="button-8 w-button" @click="createMessage"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SendMessageModal v-if="message" :cancel="closeMessage" />
    <SuccessMessageModal
      :is-open="acceptSuccess || declineSuccess"
      :cancel="endRequest"
      :message="successMessage"
      :button-action="endRequest"
    />
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import SendMessageModal from "@/components/modal/SendMessageModal";
import MessageGroupRequest from "@/model/requests/MessageGroupRequest";
import { mapState } from "vuex";
import moment from "moment/moment";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import MessageRequestRequest from "@/model/requests/MessageRequestRequest";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import SuccessMessageModal from "@/components/modal/SuccessMessageModal";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import { TimeAgo } from "vue2-timeago";
import customerMessages from "@/views/timeslot/customer/CustomerMessages";
export default {
  name: "ProfessionalMessages",
  components: {
    SuccessMessageModal,
    TimeslotDashboardLayout,
    SendMessageModal,
    BaseComponentLoader
    // TimeAgo
  },
  data() {
    return {
      searchValue: "",
      empty: false,
      nav: false,
      nav2: false,
      show: false,
      show2: false,
      message: false,
      search: false,
      header: true,
      bar: true,
      cross: false,
      readMessageByCustomerModel: MessageGroupRequest.readByCustomerId,
      viewModel: MessageGroupRequest.readBy,
      createModel: MessageRequestRequest.createMessage,
      acceptModel: MessageRequestRequest.accept,
      declineModel: MessageRequestRequest.decline,
      send: false
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      customerMessages: state => state.messageGroup.customerMessages,
      profInfo: state => state.professional.professionalInfo,
      messagesInGroup: state => state.messageGroup.messagesInGroup,
      singleMessageGroup: state => state.messageGroup.singleMessageGroup,
      acceptLoading: state => state.messageRequest.acceptLoading,
      declineLoading: state => state.messageRequest.declineLoading,
      acceptSuccess: state => state.messageRequest.acceptSuccess,
      declineSuccess: state => state.messageRequest.declineSuccess,
      professionalId: state => state.professional.professionalId,
      customerId: state => state.customer.customerId,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId,
      allCustomerMessages: state => state.messageGroup.allCustomerMessages
    }),
    ...mapState(["loader"]),
    successMessage() {
      let message = "";
      if (this.acceptSuccess) {
        message = "Message request accepted";
      }
      if (this.declineSuccess) {
        message = "Message request declined";
      }
      return message;
    }
  },
  methods: {
    formattedDate(date) {
      return moment(date).format("ll");
    },
    endRequest() {
      if (this.acceptSuccess) {
        StoreUtils.commit("messageRequest/updateAcceptSuccess", false);
      }
      if (this.declineSuccess) {
        StoreUtils.commit("messageRequest/updateDeclineSuccess", false);
      }
    },
    toggleNav() {
      this.nav = !this.nav;
    },
    toggleNav2() {
      this.nav2 = !this.nav2;
    },
    showMessage() {
      this.message = true;
    },
    closeMessage() {
      this.message = false;
    },
    openSearch() {
      this.header = false;
      this.search = true;
    },
    closeSearch() {
      this.search = false;
      this.header = true;
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    timeFromNow(date) {
      return moment(date)
        .startOf("minute")
        .fromNow();
    },
    viewMessage(value) {
      this.viewModel.messageGroupId = value.messageGroupId;
      StoreUtils.dispatch("messageGroup/readByMessageGroupId", this.viewModel);
      StoreUtils.commit("messageGroup/setSingleMessageGroup", value);
    },
    createMessage() {
      this.createModel.messageFrom = this.userInfo.customerId;
      this.createModel.messageGroupId = this.singleMessageGroup.messageGroupId;
      this.createModel.messageTo = this.singleMessageGroup.messageFrom;
      this.send = true;
      StoreUtils.dispatch("messageGroup/createMessage", this.createModel).then(
        () => {
          this.createModel.messageBody = null;
          this.send = false;
          this.viewModel.messageGroupId = this.singleMessageGroup.messageGroupId;
          StoreUtils.dispatch(
            "messageGroup/readByMessageGroupId",
            this.viewModel
          );
        }
      );
    },
    acceptMessage() {
      this.acceptModel.messageGroupId = this.singleMessageGroup.messageGroupId;
      StoreUtils.dispatch(
        "messageRequest/acceptMessageRequest",
        this.acceptModel
      ).then(() => {
        this.viewModel.messageGroupId = this.singleMessageGroup.messageGroupId;
        StoreUtils.dispatch(
          "messageGroup/readByMessageGroupId",
          this.viewModel
        );
        this.readMessageByCustomerModel.customerId = this.userInfo.customerId;
        StoreUtils.dispatch(
          "messageGroup/readByMessageGroupByCustomerId",
          this.readMessageByCustomerModel
        );
      });
    },
    goToProfile() {
      let professionalId;
      if (this.userInfo.professional.professionalId) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    },
    declineMessage() {
      this.declineModel.messageGroupId = this.singleMessageGroup.messageGroupId;
      StoreUtils.dispatch(
        "messageRequest/declineMessageRequest",
        this.declineModel
      ).then(() => {
        this.viewModel.messageGroupId = this.singleMessageGroup.messageGroupId;
        StoreUtils.dispatch(
          "messageGroup/readByMessageGroupId",
          this.viewModel
        );
        this.readMessageByCustomerModel.customerId = this.customerId;
        StoreUtils.dispatch(
          "messageGroup/readByMessageGroupByCustomerId",
          this.readMessageByCustomerModel
        );
      });
    },
    searchMessages() {
      if (this.searchValue !== null) {
        StoreUtils.commit(
          "messageGroup/setCustomerMessages",
          this.allCustomerMessages.filter(item =>
            item.messageParticipantName
              ?.toLowerCase()
              ?.includes(this.searchValue)
          )
        );
      } else {
        StoreUtils.commit(
          "messageGroup/setCustomerMessages",
          this.allCustomerMessages
        );
      }
    }
  },
  // scrollToEnd() {
  //   let content = this.$refs.messageContainer;
  //   console.log(content.scrollHeight);
  //   // content.scrollTop = content.scrollHeight;
  //   // console.log(content.scrollTop);
  //   console.log(content.offsetHeight);
  // },
  // handleUserScroll(e) {
  //   const scrollTop = e.target.scrollTop
  //   const scrollHeight = e.target.scrollHeight
  //   const elementHeight = e.target.offsetHeight
  //   if (scrollTop === 0 && elementHeight < scrollHeight) {
  //     // ... fetch older messages
  //   }
  // }
  mounted() {
    this.readMessageByCustomerModel.customerId = this.customerId;
    StoreUtils.dispatch(
      "messageGroup/readByMessageGroupByCustomerId",
      this.readMessageByCustomerModel
    ).then(() => {
      if (this.customerMessages.length > 0) {
        this.viewModel.messageGroupId = this.customerMessages[0].messageGroupId;
        StoreUtils.dispatch(
          "messageGroup/readByMessageGroupId",
          this.viewModel
        ).then(() => {
          let messagesArea = document.getElementById("messageContainer");
          messagesArea.scrollTop = messagesArea.scrollHeight;
        });
      }
    });
  }
};
</script>

<style scoped>
/*.scroll-parent *{*/
.scroll-parent {
  /*overflow-anchor: none;*/
  /*height: 100%;*/
  overflow-y: auto;
  height: 100%;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none;
  /*background-color: #960505;*/
}
.scroll-parent::-webkit-scrollbar {
  display: none;
}

.scroll-child {
  overflow-anchor: auto;
  height: 10px;
}
.accept-button {
  display: inline-block;
  padding: 15px 30px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 10px;
  background-color: #256ff6;
  text-decoration: none;
  width: 45%;
  height: 55px;
  cursor: pointer;
}
.accept-button:hover {
  color: white;
}
.decline-button {
  border-style: solid;
  border-width: 1px;
  border-color: rgba(3, 28, 67, 0.1);
  background-color: #fff;
  color: #256ff6;
  border-radius: 10px;
  padding: 15px 30px;
  display: inline-block;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  text-decoration: none;
  width: 45%;
  height: 55px;
  cursor: pointer;
}
.messages-bottom-margin {
  position: relative;
  top: 300px;
  margin-bottom: 30px;
}
.small-loader {
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.small-loader .jt {
  height: 30px;
  width: 30px;
  display: inline-block;
}
.small-loader svg {
  transform: translate(50%, 50%);
  animation: spin 0.5s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
